import { CSSProperties } from "react";
import { Theme, makeStyles } from "@material-ui/core";
import styled from "styled-components";
import Sty from "modules/Sty"
import { MEDIA_BREAKPOINTS } from "modules/Types";

export interface SHARED_WEBSITE_STYLES_PROPS {
  subHeaderText: CSSProperties & { marginBottom: number };
  editorPane: CSSProperties & { maxWidth: number };
  innerPanelSection: CSSProperties;
}

export const SHARED_WEBSITE_STYLES = makeStyles((_theme: Theme) => ({
  subHeaderText: {
    ...Sty.text18bold,
  },
  innerPanelSection: {
    padding: 16,
    borderRadius: 12,
    border: "1px solid #EDECF2",
  },
  websiteEditorCardTitles: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: 24,
    [MEDIA_BREAKPOINTS.mobileView]: {
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "flex-start",
    },
  },
}))

interface SubHeaderTextProps {
  text: string;
}

export const SubHeaderText = ({
  text,
}: SubHeaderTextProps) => {
  const classes = SHARED_WEBSITE_STYLES()
  return (
    <p className={classes.subHeaderText}>
      {text}
    </p>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  grayText: {
    color: "#707070",
    cursor: "pointer",
    fontSize: 16,
  },
  select: {
    height: 44,
    marginLeft: "auto",
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      paddingRight: theme.spacing(1.75),
    },
    [theme.breakpoints.down(361)]: {
      width: "100%",
    },
  },
}));

export interface ImageProps {
  flexDirection?: string;
  gap?: string;
  display?: string;
  padding?: string;
  backgroundColor?: string;
  alignItems?: string;
  width?: number;
  height?: number;
  marginLeft?: string;
  borderRadius?: string;
  justifyContent?: string;
}

interface TopBarContentContainerProps {
  published?: boolean;
}

export const TopBarContentContainer = styled.div<TopBarContentContainerProps>`
  width: ${({ published }) => (published ? "50%" : "fit-content")};
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  justify-content: flex-end;
  margin-left: 8px;
  ${MEDIA_BREAKPOINTS.mobileView} {
    width: fit-content;
    padding: 8px 0px 8px 8px;
    justify-content: space-between;
    margin-left: 0px;
  }
`

const sty: Record<string, CSSProperties> = {
  websiteEditorCardComponent: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    backgroundColor: "white",
    borderRadius: 12,
  },
  websiteEditorCardComponent_mobile: {
    borderRadius: 0,
  }
}

export default useStyles;
